import { UUID } from "../generic/uuid";
import { OrganisationModel } from "./organisation";
import { SellerDto } from "@vini-wine/core-dtos";

export interface SellerModel extends UUID {
  // transform
  name: string;

  // available includes
  organisation?: OrganisationModel;
}

export const createSellerDtoFromOfferSellerModel = (
  seller: SellerModel,
): SellerDto => {
  return {
    name: seller.name,
    uuid: seller.uuid,
  };
};
